import { AnalyticsProvider } from '@cosuno/analytics-frontend';
import * as Sentry from '@sentry/browser';
import React, { useMemo } from 'react';

import useCosunoIntegration from './integrations/cosuno';
import useCypressIntegration from './integrations/cypress';
import NavigationObserver from './NavigationObserver';

const RootContextProvider: React.FC<React.PropsWithChildren> = ({ children }) => {
  const cosunoIntegration = useCosunoIntegration();
  const cypressIntegration = useCypressIntegration();

  const customIntegrations = useMemo(
    () => [cosunoIntegration, cypressIntegration],
    [cosunoIntegration, cypressIntegration],
  );

  const fullStoryConfig = useMemo(
    () => ({
      region: 'EU' as const,
      Sentry: Sentry.isInitialized() && Sentry,
    }),
    [],
  );

  return (
    <AnalyticsProvider customIntegrations={customIntegrations} fullStory={fullStoryConfig}>
      <NavigationObserver />
      {children}
    </AnalyticsProvider>
  );
};

export default RootContextProvider;
